import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _ExpandMore, _ExpandMore2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Slider from 'react-slick';
import slickStyles from 'slick-carousel/slick/slick.css';
import slickStylesTheme from 'slick-carousel/slick/slick-theme.css';
import { withCookies, Cookies } from 'react-cookie';
import _ from 'lodash';
import classNames from 'classnames';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import LinearProgress from '@mui/material/LinearProgress';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AppContext from '../../context';
import CourseItem from '../../components/CourseItem/CourseItem';
import LessonItem from '../../components/LessonItem/LessonItem';
import Link from '../../components/Link';
import CircularProgressLoader from '../../components/CircularProgressLoader/CircularProgressLoader';
import { isEditor, isTourShown, isTrial, buildQuery, parseSort, getContentCategoriesForFilter } from '../../helpers';
import isLoggedIn from '../../helpers/checkAuth';
import history from '../../history';
import Arrow from './Arrow';
import ContinueLearning from './ContinueLearning';
import Filter from './Filter';
import DashboardDiscussions from './DashboardDiscussions';
import initialDefaultState from './intialState';
import { messages as tourMessages } from './Tour';
import Tour from '../../components/Tour';
import * as coursesActions from '../../actions/courses';
import * as lessonsActions from '../../actions/homeLessons';
import * as searchActions from '../../actions/search';
import * as tourActions from '../../actions/tours';
import * as authActions from '../../actions/auth';
import * as disscussionsActions from '../../actions/discussions';
import * as followedDisscussionsActions from '../../actions/dashboardDiscussions';
import s from './Courses.scss';
import messages from './coursesMessges';
import SkholeIcon41 from '../../components/statelessComponents/Icons/SkholeIcon41';
import SkholeIcon40 from '../../components/statelessComponents/Icons/SkholeIcon40';
import SkholeIcon17BiggerSize from '../../components/statelessComponents/Icons/SkholeIcon17BiggerSize';
import * as contentCategoriesActions from '../../actions/contentCategories';
import * as tagsActions from '../../actions/tags';
import CircularProgressSmall from '../../components/CircularProgressSmall';
import { COURSE_TYPES_FILTER_VALUES } from '../../constants';
import intlPropTypes from '../../constants/intlPropTypes';
var Courses = (_dec = withStyles(slickStyles), _dec2 = withStyles(slickStylesTheme), _dec3 = withStyles(s), _dec4 = connect(function (state) {
  return {
    loadingCourses: state.courses.loading,
    loadedCourses: state.courses.loaded,
    courses: state.courses.courses,
    totalCourses: state.courses.total,
    loadingLessons: state.homeLessons.loading,
    loadedLessons: state.homeLessons.loaded,
    lessons: state.homeLessons.lessons,
    totalLessons: state.homeLessons.total,
    auth: state.auth,
    favoriteCourses: state.auth.favoriteCourses,
    tags: state.tags.tags,
    loadingTags: state.tags.loading,
    isLoadedTags: state.tags.loaded,
    pendingTags: state.search.pendingTags,
    selectedTags: state.search.tags,
    wereTagsEmpty: state.tags.wereEmpty,
    contentCategories: state.contentCategories.contentCategories,
    loadingContentCategories: state.contentCategories.loading,
    isLoadedContentCategories: state.contentCategories.loaded,
    pendingContentCategories: state.search.pendingContentCategories,
    search: state.search.search,
    selectedContentCategories: state.search.contentCategories,
    lang: state.intl.locale,
    dashboardData: state.auth.dashboardData,
    loadingDashboardData: state.auth.loadingDashboardData,
    loadedDashboardData: state.auth.loadedDashboardData,
    notifications: state.notifications.notifications,
    discussions: state.discussions.discussions,
    loadedDiscussions: state.discussions.loaded,
    loadingDiscussions: state.discussions.loading,
    followedDiscussions: state.followedDiscussions.followedDiscussions,
    loadedFollowedDiscussions: state.followedDiscussions.loaded,
    loadingFollowedDiscussions: state.followedDiscussions.loading,
    isNotificationsMenuOpened: state.search.isNotificationsMenuOpened,
    isTourOpen: isTourShown(state, 'courses'),
    searchSessionId: state.search.searchSession._id
  };
}, function (dispatch) {
  return bindActionCreators(_objectSpread(_objectSpread(_objectSpread({
    getCourses: coursesActions.getCourses,
    resetCourses: coursesActions.reset
  }, lessonsActions), followedDisscussionsActions), {}, {
    loadAuth: authActions.loadAuth,
    getDiscussions: disscussionsActions.getDiscussions,
    resetDiscussions: disscussionsActions.reset,
    saveFavoriteCourses: authActions.saveFavoriteCourses,
    getDashboardData: authActions.getDashboardData,
    resetDashboardData: authActions.resetDashboardData,
    toggleNotificationsPopover: searchActions.toggleNotificationsPopover,
    toggleTour: tourActions.toggleTour,
    getContentCategories: contentCategoriesActions.getContentCategories,
    resetContentCategories: contentCategoriesActions.reset,
    getTags: tagsActions.getTags,
    resetTags: tagsActions.reset
  }, searchActions), dispatch);
}), _dec5 = connect(), injectIntl(_class = withCookies(_class = _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Courses, _React$Component);
  var _super = _createSuper(Courses);
  function Courses(props, context) {
    var _context$contentLangs, _context$contentLangs2;
    var _this;
    _classCallCheck(this, Courses);
    _this = _super.call(this, props, context);
    _defineProperty(_assertThisInitialized(_this), "sliderSettings", {
      dots: false,
      infinite: true,
      arrows: true,
      accessibility: false,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });
    _defineProperty(_assertThisInitialized(_this), "headerLogoLink", null);
    _defineProperty(_assertThisInitialized(_this), "initialState", _objectSpread({}, initialDefaultState));
    _defineProperty(_assertThisInitialized(_this), "bindHeaderLogoClick", function () {
      var nextLink = _.get(_assertThisInitialized(_this), 'context.headerRef.logoBtnRef.link');
      if (!nextLink || _this.headerLogoLink === nextLink) {
        return;
      }
      if (_this.headerLogoLink) {
        _this.headerLogoLink.removeEventListener('click', _this.clearFilter);
      }
      nextLink.addEventListener('click', _this.clearFilter);
      _this.headerLogoLink = nextLink;
    });
    _defineProperty(_assertThisInitialized(_this), "getCurrentContentLang", function () {
      var _this$context$content;
      return _this.state.contentLangId === 'all' ? undefined : (_this$context$content = _this.context.contentLangs) === null || _this$context$content === void 0 ? void 0 : _this$context$content.find(function (item) {
        return item._id === _this.state.contentLangId;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onFilterChange", function (event) {
      var filter = event.target.value;
      if (filter === 'all') {
        filter = '';
      }
      var oldFilter = _this.state.filter;
      if (filter === oldFilter) {
        return;
      }
      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          lessonsPage: 1,
          coursesPage: 1,
          filter: filter
        });
      }, _this.updateHistoryQueryParams);
    });
    _defineProperty(_assertThisInitialized(_this), "onContentLanguageChange", function (event) {
      var _this$context$content2, _this$context$content3;
      var contentLangId = event.target.value;
      var oldContentLangId = _this.state.contentLangId;
      if (contentLangId === oldContentLangId) {
        return;
      }
      _this.props.resetTags();
      _this.props.dispatch(searchActions.changePendingTagsField([]));
      _this.props.dispatch(searchActions.changeTagsField([]));
      _this.props.getTags({
        page: 1,
        perPage: 1000,
        sort: 'name',
        contentLangId: contentLangId === 'all' ? undefined : (_this$context$content2 = _this.context.contentLangs) === null || _this$context$content2 === void 0 ? void 0 : (_this$context$content3 = _this$context$content2.find(function (item) {
          return item._id === contentLangId;
        })) === null || _this$context$content3 === void 0 ? void 0 : _this$context$content3._id,
        isHomePageSearch: true
      });
      _this.props.changeTagsField([]);
      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          lessonsPage: 1,
          coursesPage: 1,
          contentLangId: contentLangId
        });
      }, _this.updateHistoryQueryParams);
    });
    _defineProperty(_assertThisInitialized(_this), "onContentTypeChange", function (event) {
      var type = event.target.value;
      if (type === 'all') {
        type = '';
      }
      var oldContentType = _this.state.type;
      if (type === oldContentType) {
        return;
      }
      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          lessonsPage: 1,
          coursesPage: 1,
          type: type
        });
      }, _this.updateHistoryQueryParams);
    });
    _defineProperty(_assertThisInitialized(_this), "getCurrentQueryParams", function (fieldToOmit) {
      var _this$state = _this.state,
        filter = _this$state.filter,
        sort = _this$state.sort,
        perPage = _this$state.perPage,
        coursesPage = _this$state.coursesPage,
        contentLangId = _this$state.contentLangId,
        type = _this$state.type;
      var _this$props = _this.props,
        tags = _this$props.tags,
        selectedTags = _this$props.selectedTags,
        search = _this$props.search,
        selectedContentCategories = _this$props.selectedContentCategories,
        contentCategories = _this$props.contentCategories,
        listMode = _this$props.listMode;
      var params = {
        sort: sort,
        page: coursesPage,
        search: _.trim(search).length < 3 ? '' : _.trim(search),
        perPage: perPage,
        filter: filter,
        contentLangId: contentLangId,
        type: type
      };
      if (listMode) {
        params.listMode = true;
      }
      if (selectedTags && selectedTags.length && (tags.length !== selectedTags.length || tags.length === 1)) {
        params.tags = selectedTags;
      }
      if (selectedContentCategories && selectedContentCategories.length && (contentCategories.length !== selectedContentCategories.length || contentCategories.length === 1)) {
        params.contentCategories = selectedContentCategories;
      }
      _.forIn(params, function (value, key) {
        if (!value) {
          delete params[key];
        }
      });
      return _.omit(params, fieldToOmit);
    });
    _defineProperty(_assertThisInitialized(_this), "setIsColumnDisplayMode", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(listMode) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isLoggedIn(_this.props.auth)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this.props.dispatch(authActions.toggleListMode(listMode));
            case 3:
              _this.props.resetCourses();
              _this.props.resetLessons();
              _this.setState({
                listMode: listMode
              });
              _this.updateHistoryQueryParams({
                listMode: listMode
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "loadMoreCourses", function () {
      var loadingCourses = _this.props.loadingCourses;
      var coursesPage = _this.state.coursesPage;
      if (!_this.hasMoreCourses() || loadingCourses) return;
      _this.setState({
        coursesPage: coursesPage + 1
      }, _this.loadCourses);
    });
    _defineProperty(_assertThisInitialized(_this), "loadMoreLessons", function () {
      var loadingLessons = _this.props.loadingLessons;
      var lessonsPage = _this.state.lessonsPage;
      if (!_this.hasMoreLessons() || loadingLessons) return;
      _this.setState({
        lessonsPage: lessonsPage + 1
      }, _this.loadLessons);
    });
    _defineProperty(_assertThisInitialized(_this), "loadCourses", function () {
      var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var doNotAppend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var getCourses = _this.props.getCourses;
      var currentQueryParams = _this.getCurrentQueryParams();
      if (currentQueryParams.contentLangId === 'all' || currentQueryParams.search) {
        currentQueryParams.contentLangId = undefined;
      }
      if (currentQueryParams.search) {
        currentQueryParams.tags = [];
        currentQueryParams.contentCategories = [];
        currentQueryParams.sort = '';
      }
      getCourses(_.assign({
        includeNotAvailable: true
      }, currentQueryParams, queryParams), doNotAppend);
    });
    _defineProperty(_assertThisInitialized(_this), "loadLessons", function () {
      var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var doNotAppend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props2 = _this.props,
        getLessons = _this$props2.getLessons,
        search = _this$props2.search;
      if (!search) {
        return;
      }
      var currentQueryParams = _this.getCurrentQueryParams(['filter', 'type', 'tags']);
      if (currentQueryParams.contentLangId === 'all' || search) {
        currentQueryParams.contentLangId = undefined;
      }
      var lessonsPage = _this.state.lessonsPage;
      var params = _objectSpread(_objectSpread({}, currentQueryParams), {}, {
        page: lessonsPage,
        isHomePage: true,
        withoutPopulation: true,
        includeNotAvailable: true
      });
      getLessons(_.assign({}, queryParams, params), doNotAppend);
    });
    _defineProperty(_assertThisInitialized(_this), "hasMoreCourses", function () {
      var totalCourses = _this.props.totalCourses;
      var _this$state2 = _this.state,
        perPage = _this$state2.perPage,
        coursesPage = _this$state2.coursesPage;
      return Math.ceil(totalCourses / perPage) > coursesPage;
    });
    _defineProperty(_assertThisInitialized(_this), "hasMoreLessons", function () {
      var totalLessons = _this.props.totalLessons;
      var _this$state3 = _this.state,
        perPage = _this$state3.perPage,
        lessonsPage = _this$state3.lessonsPage;
      return Math.ceil(totalLessons / perPage) > lessonsPage;
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnScroll", function () {
      var scrollTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      var scrollHeight = document.documentElement && document.documentElement.scrollHeight || document.body.scrollHeight;
      var clientHeight = document.documentElement.clientHeight || window.innerHeight;
      var scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight - 0.3 * scrollHeight;
      var filledSearch = _.trim(_this.props.search).length > 2;
      if (scrolledToBottom && !filledSearch) {
        _this.loadMoreCourses();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "changeSort", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
        var value, orderBy, order, sort;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              value = _ref2.target.value;
              orderBy = value;
              order = _this.state.order;
              sort = _.map(orderBy.split(','), function (item) {
                return "".concat(order === 'desc' ? '-' : '').concat(item);
              }).join(',');
              _this.setState({
                orderBy: orderBy,
                sort: sort,
                coursesPage: 1,
                lessonsPage: 1
              }, _this.updateHistoryQueryParams);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "changeSortOrder", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
        var value, order, orderBy, sort;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              value = _ref4.target.value;
              order = value;
              orderBy = _this.state.orderBy;
              sort = _.map(orderBy.split(','), function (item) {
                return "".concat(order === 'desc' ? '-' : '').concat(item);
              }).join(',');
              _this.setState({
                order: order,
                sort: sort,
                coursesPage: 1,
                lessonsPage: 1
              }, _this.updateHistoryQueryParams);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "afterCourseRemovedFromFavorite", function () {
      var filter = _this.state.filter;
      if (filter === COURSE_TYPES_FILTER_VALUES.MY_COURSES) {
        _this.updateHistoryQueryParams();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDashboardExpander", function () {
      _this.setState(function (prevState) {
        return {
          isDashboardExpanded: !prevState.isDashboardExpanded
        };
      }, _this.toggleDashboardCookie);
    });
    _defineProperty(_assertThisInitialized(_this), "isDashboardNotEmpty", function () {
      var _this$props3 = _this.props,
        dashboardData = _this$props3.dashboardData,
        followedDiscussions = _this$props3.followedDiscussions,
        discussions = _this$props3.discussions,
        loadedDashboardData = _this$props3.loadedDashboardData,
        loadedDiscussions = _this$props3.loadedDiscussions,
        loadedFollowedDiscussions = _this$props3.loadedFollowedDiscussions;
      var lastItem = _.get(dashboardData, 'courseWithTime');
      var isDashboardLoaded = loadedDashboardData && loadedDiscussions && loadedFollowedDiscussions;
      return isDashboardLoaded && (discussions && discussions.length || followedDiscussions && followedDiscussions.length || lastItem || _.get(dashboardData, 'tasks') || _.get(dashboardData, 'quizResult') || _.get(dashboardData, 'examResult'));
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDashboardCookie", function () {
      if (_this.state.isDashboardExpanded === false) {
        _this.props.cookies.remove("".concat(_this.context.cookiePrefix, "isDashboardShown"), {
          path: '/',
          domain: window.App.cookieDomain
        });
      } else if (_this.isDashboardNotEmpty()) {
        _this.props.cookies.set("".concat(_this.context.cookiePrefix, "isDashboardShown"), true, {
          path: '/',
          domain: window.App.cookieDomain
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpenNotificationPopover", function () {
      var isNotificationsMenuOpened = _this.props.isNotificationsMenuOpened;
      _this.props.toggleNotificationsPopover(!isNotificationsMenuOpened);
    });
    _defineProperty(_assertThisInitialized(_this), "updateHistoryQueryParams", function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var query = _objectSpread(_objectSpread({}, _this.getCurrentQueryParams(['perPage', 'page'])), params);
      if (_.get(params, 'listMode') === false) {
        delete query.listMode;
      }
      history.push({
        search: "?".concat(buildQuery(query))
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hasPristineState", function () {
      return _.isEqual(_this.getCurrentFiltersState(), _this.initialState);
    });
    _defineProperty(_assertThisInitialized(_this), "getCurrentFiltersState", function () {
      var _this$state4 = _this.state,
        sort = _this$state4.sort,
        filter = _this$state4.filter,
        contentLangId = _this$state4.contentLangId,
        type = _this$state4.type;
      var _this$props4 = _this.props,
        search = _this$props4.search,
        selectedContentCategories = _this$props4.selectedContentCategories,
        selectedTags = _this$props4.selectedTags;
      return {
        search: _.trim(search).length > 2 ? search : '',
        sort: sort,
        filter: filter,
        contentCategories: selectedContentCategories,
        tags: selectedTags,
        contentLangId: contentLangId,
        type: type
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getAmountAppliedFilters", function () {
      if (_this.hasPristineState()) {
        return 0;
      }
      var currentFilters = _this.getCurrentFiltersState();
      var amountApplied = 0;
      Object.keys(_this.initialState).forEach(function (key) {
        if (_.isArray(currentFilters[key])) {
          var _$xor;
          amountApplied += ((_$xor = _.xor(_this.initialState[key], currentFilters[key])) === null || _$xor === void 0 ? void 0 : _$xor.length) || 0;
        } else if (_this.initialState[key] !== currentFilters[key]) {
          amountApplied += 1;
        }
      });
      return amountApplied;
    });
    _defineProperty(_assertThisInitialized(_this), "clearFilter", function (event) {
      var auth = _this.props.auth;
      if (_this.hasPristineState()) {
        return;
      }
      event.preventDefault();
      _this.handleFiltersMobileExpanded();
      _this.setState(_objectSpread(_objectSpread({}, _this.initialState), parseSort(_this.initialState.sort)), function () {
        Promise.all([_this.props.dispatch(searchActions.changeSearchField('')), _this.props.dispatch(searchActions.changeSearchSession('', '')), _this.props.dispatch(searchActions.changePendingTagsField([])), _this.props.dispatch(searchActions.changeTagsField([])), _this.props.dispatch(searchActions.changePendingContentCategoriesField(getContentCategoriesForFilter(auth) || [])), _this.props.dispatch(searchActions.changeContentCategoriesField(getContentCategoriesForFilter(auth) || []))]).then(function () {
          _this.updateHistoryQueryParamsDebounced();
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleToggleTag", function (value) {
      return function () {
        var pendingTags = _this.props.pendingTags;
        var currentIndex = pendingTags.indexOf(value);
        var newTags = _toConsumableArray(pendingTags);
        if (currentIndex === -1) {
          newTags.push(value);
        } else {
          newTags.splice(currentIndex, 1);
        }
        _this.props.changePendingTagsField(newTags);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "toggleSelectAllTags", function () {
      var _this$props5 = _this.props,
        tags = _this$props5.tags,
        pendingTags = _this$props5.pendingTags,
        changePendingTagsField = _this$props5.changePendingTagsField;
      if (pendingTags.length) {
        _this.props.changePendingTagsField([]);
        return;
      }
      changePendingTagsField(tags.map(function (item) {
        return item._id;
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "handleToggleContentCategory", function (value) {
      return function () {
        var pendingContentCategories = _this.props.pendingContentCategories;
        var currentIndex = pendingContentCategories.indexOf(value);
        var newContentCategories = _toConsumableArray(pendingContentCategories);
        if (currentIndex === -1) {
          newContentCategories.push(value);
        } else {
          newContentCategories.splice(currentIndex, 1);
        }
        _this.props.changePendingContentCategoriesField(newContentCategories);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "toggleSelectAllContentCategories", function () {
      var _this$props6 = _this.props,
        contentCategories = _this$props6.contentCategories,
        pendingContentCategories = _this$props6.pendingContentCategories,
        changePendingContentCategoriesField = _this$props6.changePendingContentCategoriesField;
      if (pendingContentCategories.length) {
        _this.props.changePendingContentCategoriesField([]);
        return;
      }
      changePendingContentCategoriesField(contentCategories.map(function (item) {
        return item._id;
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "handleExpandTagsIndex", function () {
      _this.setState({
        isTagsIndexExpanded: true
      });
      _this.props.changePendingTagsField(_this.props.selectedTags);
    });
    _defineProperty(_assertThisInitialized(_this), "handleExpandIndex", function () {
      _this.setState({
        isIndexExpanded: true
      });
      _this.props.changePendingContentCategoriesField(_this.props.selectedContentCategories);
    });
    _defineProperty(_assertThisInitialized(_this), "handleCollapseTagsIndex", function () {
      var _this$props7 = _this.props,
        changeTagsField = _this$props7.changeTagsField,
        pendingTags = _this$props7.pendingTags,
        selectedTags = _this$props7.selectedTags,
        changeSearchSession = _this$props7.changeSearchSession;
      var isTagsChanged = !_.isEqual(_.sortBy(pendingTags), _.sortBy(selectedTags));
      var _this$state5 = _this.state,
        lessonsPage = _this$state5.lessonsPage,
        coursesPage = _this$state5.coursesPage;
      if (isTagsChanged) {
        lessonsPage = 1;
        coursesPage = 1;
      }
      _this.setState({
        isTagsIndexExpanded: false,
        lessonsPage: lessonsPage,
        coursesPage: coursesPage
      }, function () {
        changeTagsField(pendingTags);
        changeSearchSession('', '');
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCollapseIndex", function () {
      var _this$props8 = _this.props,
        changeContentCategoriesField = _this$props8.changeContentCategoriesField,
        pendingContentCategories = _this$props8.pendingContentCategories,
        selectedContentCategories = _this$props8.selectedContentCategories,
        changeSearchSession = _this$props8.changeSearchSession;
      var isContentCategoriesChanged = !_.isEqual(_.sortBy(pendingContentCategories), _.sortBy(selectedContentCategories));
      var _this$state6 = _this.state,
        lessonsPage = _this$state6.lessonsPage,
        coursesPage = _this$state6.coursesPage;
      if (isContentCategoriesChanged) {
        lessonsPage = 1;
        coursesPage = 1;
      }
      _this.setState({
        isIndexExpanded: false,
        lessonsPage: lessonsPage,
        coursesPage: coursesPage
      }, function () {
        changeContentCategoriesField(pendingContentCategories);
        changeSearchSession('', '');
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleFiltersMobileExpanded", function () {
      _this.setState(function (prevState) {
        return {
          isFiltersMobileExpanded: !prevState.isFiltersMobileExpanded
        };
      });
    });
    var initialState = _objectSpread(_objectSpread({}, _this.initialState || {}), {}, {
      contentLangId: (_context$contentLangs = context.contentLangs) === null || _context$contentLangs === void 0 ? void 0 : (_context$contentLangs2 = _context$contentLangs.find(function (item) {
        return item.lang === _this.props.intl.locale;
      })) === null || _context$contentLangs2 === void 0 ? void 0 : _context$contentLangs2._id,
      contentCategories: getContentCategoriesForFilter(props.auth) || []
    });
    _this.initialState = initialState;
    _this.state = _objectSpread(_objectSpread({
      perPage: 32,
      coursesPage: _.get(props, 'page', 1),
      filter: _.get(context, 'query.filter', _this.initialState.filter),
      sort: _.get(context, 'query.sort', _this.initialState.sort)
    }, parseSort(_.get(context, 'query.sort', _this.initialState.sort))), {}, {
      lessonsPage: 1,
      isDashboardExpanded: _this.props.cookies.get("".concat(context.cookiePrefix, "isDashboardShown")) || false,
      isIndexExpanded: false,
      isTagsIndexExpanded: false,
      isFiltersMobileExpanded: false,
      listMode: _this.props.listMode,
      organizationCourses: _.get(props, 'courses', []),
      contentLangId: _.get(context, 'query.contentLangId', _this.initialState.contentLangId),
      type: _.get(context, 'query.type', _this.initialState.type)
    });
    _this.updateHistoryQueryParamsDebounced = _.debounce(_this.updateHistoryQueryParams, 800);
    return _this;
  }
  _createClass(Courses, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$getCurrentConte2;
      var _this$props9 = this.props,
        getDashboardData = _this$props9.getDashboardData,
        getDiscussions = _this$props9.getDiscussions,
        getFollowedDiscussions = _this$props9.getFollowedDiscussions,
        auth = _this$props9.auth,
        getContentCategories = _this$props9.getContentCategories,
        changePendingContentCategoriesField = _this$props9.changePendingContentCategoriesField,
        getTags = _this$props9.getTags,
        changePendingTagsField = _this$props9.changePendingTagsField;
      changePendingTagsField(this.props.selectedTags);
      changePendingContentCategoriesField(this.props.selectedContentCategories);
      window.addEventListener('scroll', this.handleOnScroll);
      if (isLoggedIn(auth)) {
        getDashboardData({});
        getDiscussions({
          page: 1,
          perPage: 3,
          sort: 'createDate'
        });
        getFollowedDiscussions({
          followed: true,
          page: 1,
          perPage: 3,
          sort: 'createDate'
        });
        if (getContentCategoriesForFilter(auth)) {
          var _this$getCurrentConte;
          getContentCategories({
            page: 1,
            perPage: 50,
            sort: "name.".concat((_this$getCurrentConte = this.getCurrentContentLang()) === null || _this$getCurrentConte === void 0 ? void 0 : _this$getCurrentConte.lang),
            search: '',
            isGeneral: false
          });
          this.props.dispatch(searchActions.setIsInitialContentCategoriesLoad(false));
        }
      }
      this.bindHeaderLogoClick();
      getTags({
        page: 1,
        perPage: 1000,
        sort: 'name',
        contentLangId: (_this$getCurrentConte2 = this.getCurrentContentLang()) === null || _this$getCurrentConte2 === void 0 ? void 0 : _this$getCurrentConte2._id,
        isHomePageSearch: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(prevProps) {
        var filledSearch, nextFilledSearch;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.bindHeaderLogoClick();
              if (!(_.get(this, 'props.auth.user._id') && _.get(this, 'props.auth.user._id') !== _.get(prevProps, 'auth.user._id'))) {
                _context4.next = 4;
                break;
              }
              // eslint-disable-next-line react/no-did-update-set-state
              this.setState(_objectSpread({
                filter: '',
                type: '',
                sort: '-publishedUpdatedDate'
              }, parseSort('-publishedUpdatedDate')), this.updateHistoryQueryParams);
              return _context4.abrupt("return");
            case 4:
              filledSearch = _.trim(prevProps.search).length > 2;
              nextFilledSearch = _.trim(this.props.search).length > 2;
              if (!(this.props.search !== prevProps.search && (!filledSearch && nextFilledSearch || filledSearch && nextFilledSearch || filledSearch && !nextFilledSearch))) {
                _context4.next = 11;
                break;
              }
              if (nextFilledSearch && this.state.isDashboardExpanded) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                  isDashboardExpanded: false
                });
              }
              // eslint-disable-next-line react/no-did-update-set-state
              this.setState({
                lessonsPage: 1,
                coursesPage: 1
              });
              this.updateHistoryQueryParamsDebounced();
              return _context4.abrupt("return");
            case 11:
              if (!_.isEqual(this.props.selectedContentCategories, prevProps.selectedContentCategories) || !_.isEqual(this.props.selectedTags, prevProps.selectedTags)) {
                this.updateHistoryQueryParams();
              }
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function componentDidUpdate(_x4) {
        return _componentDidUpdate.apply(this, arguments);
      }
      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props10 = this.props,
        resetTags = _this$props10.resetTags,
        resetContentCategories = _this$props10.resetContentCategories,
        resetCourses = _this$props10.resetCourses,
        resetLessons = _this$props10.resetLessons,
        resetDashboardData = _this$props10.resetDashboardData,
        dispatch = _this$props10.dispatch,
        searchSessionId = _this$props10.searchSessionId,
        search = _this$props10.search;
      window.removeEventListener('scroll', this.handleOnScroll);
      if (this.headerLogoLink) {
        this.headerLogoLink.removeEventListener('click', this.clearFilter);
        this.headerLogoLink = null;
      }
      dispatch(searchActions.changeSearchSession(searchSessionId, search));
      dispatch(searchActions.changeSearchField(''));
      resetTags();
      resetContentCategories();
      resetCourses();
      resetDashboardData();
      resetLessons();
      this.props.dispatch(searchActions.setIsInitialContentCategoriesLoad(true));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props11 = this.props,
        loadingCourses = _this$props11.loadingCourses,
        loadedCourses = _this$props11.loadedCourses,
        courses = _this$props11.courses,
        loadingLessons = _this$props11.loadingLessons,
        loadedLessons = _this$props11.loadedLessons,
        lessons = _this$props11.lessons,
        dashboardData = _this$props11.dashboardData,
        notifications = _this$props11.notifications,
        auth = _this$props11.auth,
        followedDiscussions = _this$props11.followedDiscussions,
        discussions = _this$props11.discussions,
        formatMessage = _this$props11.intl.formatMessage,
        isTourOpen = _this$props11.isTourOpen,
        toggleTour = _this$props11.toggleTour,
        totalCourses = _this$props11.totalCourses,
        totalLessons = _this$props11.totalLessons,
        loadingDashboardData = _this$props11.loadingDashboardData,
        loadedDashboardData = _this$props11.loadedDashboardData,
        loadedDiscussions = _this$props11.loadedDiscussions,
        loadedFollowedDiscussions = _this$props11.loadedFollowedDiscussions,
        loadingDiscussions = _this$props11.loadingDiscussions,
        loadingFollowedDiscussions = _this$props11.loadingFollowedDiscussions,
        search = _this$props11.search,
        pendingContentCategories = _this$props11.pendingContentCategories,
        contentCategories = _this$props11.contentCategories,
        loadingContentCategories = _this$props11.loadingContentCategories,
        isLoadedContentCategories = _this$props11.isLoadedContentCategories,
        searchSessionId = _this$props11.searchSessionId,
        pendingTags = _this$props11.pendingTags,
        tags = _this$props11.tags,
        loadingTags = _this$props11.loadingTags,
        isLoadedTags = _this$props11.isLoadedTags,
        wereTagsEmpty = _this$props11.wereTagsEmpty;
      var _this$state7 = this.state,
        filter = _this$state7.filter,
        order = _this$state7.order,
        orderBy = _this$state7.orderBy,
        isIndexExpanded = _this$state7.isIndexExpanded,
        isFiltersMobileExpanded = _this$state7.isFiltersMobileExpanded,
        displayItemsInColumn = _this$state7.listMode,
        organizationCourses = _this$state7.organizationCourses,
        contentLangId = _this$state7.contentLangId,
        type = _this$state7.type,
        isTagsIndexExpanded = _this$state7.isTagsIndexExpanded;
      var lastItem = organizationCourses.length === 1 && _.get(dashboardData, 'courseWithTime._id') !== _.get(organizationCourses[0], '_id') && _.get(dashboardData, 'courseWithTime') || organizationCourses.length > 1 && _.get(dashboardData, 'courseWithTime');
      var newUserWithoutCourse = _.get(auth, 'user.loginNumber', 0) <= 1 && !lastItem && (_.isEmpty(discussions) || _.isEmpty(followedDiscussions));
      var isDashboardExpanded = this.state.isDashboardExpanded;
      var unreadNotifications = _.filter(notifications, function (_ref6) {
        var readDate = _ref6.readDate;
        return !readDate;
      }).length;
      var filledSearch = _.trim(search).length > 2;
      var isDashboardLoaded = loadedDashboardData && loadedDiscussions && loadedFollowedDiscussions;
      var isDashboardNotEmpty = this.isDashboardNotEmpty();
      return /*#__PURE__*/_jsx("main", {
        className: s.root
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.container
      }, void 0, isLoggedIn(auth) && /*#__PURE__*/_jsx("section", {
        className: classNames(newUserWithoutCourse ? s.newUserDashboard : s.dashboard, isDashboardExpanded ? s.expanded : '', _.isEmpty(followedDiscussions) && _.isEmpty(discussions) ? s.shrink : ''),
        id: "dashboard"
      }, void 0, isDashboardExpanded && loadedDashboardData && loadedDiscussions && loadedFollowedDiscussions && (!_.isEmpty(followedDiscussions) || !_.isEmpty(discussions) ? /*#__PURE__*/React.createElement(Slider, _extends({}, this.sliderSettings, {
        nextArrow: /*#__PURE__*/_jsx(Arrow, {
          customClassName: s.nextArrow,
          Component: SkholeIcon40
        }),
        prevArrow: /*#__PURE__*/_jsx(Arrow, {
          customClassName: s.prevArrow,
          Component: SkholeIcon41
        }),
        className: classNames(s.dashboardContent, s.notDisplayOnDekstopAndTablet)
      }), dashboardData && /*#__PURE__*/_jsx(ContinueLearning, {
        classNames: s,
        formatMessage: formatMessage,
        course: lastItem,
        tasks: _.get(dashboardData, 'tasks'),
        exam: _.get(dashboardData, 'examResult'),
        quiz: dashboardData && dashboardData.quizResult,
        unreadNotifications: unreadNotifications,
        user: auth.user,
        afterCourseRemovedFromFavorite: this.afterCourseRemovedFromFavorite,
        handleOpenNotificationPopover: this.handleOpenNotificationPopover
      }), (discussions || followedDiscussions) && !isTrial(auth) && /*#__PURE__*/_jsx(DashboardDiscussions, {
        followedDiscussions: followedDiscussions,
        discussions: discussions
      })) : /*#__PURE__*/_jsx("div", {
        className: classNames(s.dashboardContent, s.notDisplayOnDekstopAndTablet, _.isEmpty(followedDiscussions) && _.isEmpty(discussions) ? s.shrink : '', _defineProperty({}, s.empty, isDashboardLoaded && !isDashboardNotEmpty))
      }, void 0, isDashboardLoaded && !isDashboardNotEmpty && /*#__PURE__*/React.createElement(FormattedMessage, messages.emptyDashboard), isDashboardLoaded && isDashboardNotEmpty && dashboardData && /*#__PURE__*/_jsx(ContinueLearning, {
        classNames: classNames(s.notDisplayOnDekstopAndTablet),
        formatMessage: formatMessage,
        course: lastItem,
        tasks: _.get(dashboardData, 'tasks'),
        exam: _.get(dashboardData, 'examResult'),
        quiz: _.get(dashboardData, 'quizResult'),
        unreadNotifications: unreadNotifications,
        user: auth.user,
        afterCourseRemovedFromFavorite: this.afterCourseRemovedFromFavorite,
        handleOpenNotificationPopover: this.handleOpenNotificationPopover
      }))), isDashboardExpanded && /*#__PURE__*/_jsx("div", {
        className: classNames(s.dashboardContent, s.notDisplayOnMobile, _.isEmpty(followedDiscussions) && _.isEmpty(discussions) ? s.shrink : '', _defineProperty({}, s.empty, isDashboardLoaded && !isDashboardNotEmpty))
      }, void 0, isDashboardLoaded && !isDashboardNotEmpty && /*#__PURE__*/React.createElement(FormattedMessage, messages.emptyDashboard), isDashboardLoaded && isDashboardNotEmpty && dashboardData && /*#__PURE__*/_jsx(ContinueLearning, {
        classNames: s,
        formatMessage: formatMessage,
        course: lastItem,
        tasks: _.get(dashboardData, 'tasks'),
        exam: _.get(dashboardData, 'examResult'),
        quiz: _.get(dashboardData, 'quizResult'),
        unreadNotifications: unreadNotifications,
        user: auth.user,
        afterCourseRemovedFromFavorite: this.afterCourseRemovedFromFavorite,
        handleOpenNotificationPopover: this.handleOpenNotificationPopover,
        inRow: _.isEmpty(discussions) && _.isEmpty(followedDiscussions)
      }), (discussions || followedDiscussions) && !isTrial(auth) && /*#__PURE__*/_jsx(DashboardDiscussions, {
        followedDiscussions: followedDiscussions,
        discussions: discussions
      })), /*#__PURE__*/_jsx("div", {
        className: classNames(s.dashboardExpanderWrapper)
      }, void 0, isDashboardLoaded && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "opE3IeZqrjWOVAGX1VPgD",
        className: s.button,
        onClick: this.toggleDashboardExpander,
        id: "toggle-dashboard",
        disabled: loadingDashboardData || loadingDiscussions || loadingFollowedDiscussions
      }, void 0, isDashboardExpanded ? /*#__PURE__*/React.createElement(FormattedMessage, messages.hideDashboardBtnLabel) : /*#__PURE__*/React.createElement(FormattedMessage, messages.showDashboardBtnLabel), /*#__PURE__*/_jsx(ExpandMore, {
        className: s.dashboardExpanderIcon
      }))), (loadingDashboardData || loadingDiscussions || loadingFollowedDiscussions) && /*#__PURE__*/_jsx(LinearProgress, {
        className: s.dashboardProgress
      })), /*#__PURE__*/_jsx(Filter, {
        classNames: s,
        filter: filter,
        onFilterChange: this.onFilterChange,
        onChangeSort: this.changeSort,
        onChangeSortOrder: this.changeSortOrder,
        sortValue: orderBy,
        sortOrderValue: order,
        search: search,
        clearFilter: this.clearFilter,
        hasPristineState: this.hasPristineState(),
        auth: auth,
        categories: contentCategories,
        pendingCategories: pendingContentCategories,
        handleExpandIndex: this.handleExpandIndex,
        handleCollapseIndex: this.handleCollapseIndex,
        isIndexExpanded: isIndexExpanded,
        loadingCourses: loadingCourses,
        loadingContentCategories: loadingContentCategories,
        isLoadedContentCategories: isLoadedContentCategories,
        toggleSelectAllContentCategories: this.toggleSelectAllContentCategories,
        handleToggleContentCategory: this.handleToggleContentCategory,
        isFiltersMobileExpanded: isFiltersMobileExpanded,
        handleFiltersMobileExpanded: this.handleFiltersMobileExpanded,
        setIsColumnDisplayMode: this.setIsColumnDisplayMode,
        displayItemsInColumn: displayItemsInColumn,
        onContentLanguageChange: this.onContentLanguageChange,
        contentLangId: contentLangId,
        type: type,
        onContentTypeChange: this.onContentTypeChange,
        amountApplied: this.getAmountAppliedFilters(),
        tags: tags,
        pendingTags: pendingTags,
        loadingTags: loadingTags,
        isLoadedTags: isLoadedTags,
        toggleSelectAllTags: this.toggleSelectAllTags,
        handleToggleTag: this.handleToggleTag,
        isTagsIndexExpanded: isTagsIndexExpanded,
        handleCollapseTagsIndex: this.handleCollapseTagsIndex,
        handleExpandTagsIndex: this.handleExpandTagsIndex,
        wereTagsEmpty: wereTagsEmpty
      }), /*#__PURE__*/_jsx("section", {
        className: classNames(s.listWrapper, filledSearch && loadedCourses && !totalCourses ? s.hidden : undefined),
        id: "courses-list"
      }, void 0, filledSearch && loadedCourses && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("hr", {
        className: s.searchResultsHr
      }), /*#__PURE__*/_jsx(Typography, {
        className: s.searchResultsTitle,
        component: "h2",
        variant: "h6",
        gutterBottom: true
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.courses), /*#__PURE__*/_jsx("span", {
        className: s.searchResultsCount
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.searchCoursesResults, {
        values: {
          total: totalCourses > 50 ? "50+" : totalCourses
        }
      }))))), loadingCourses && /*#__PURE__*/_jsx(CircularProgressLoader, {
        rootClassName: s.loader
      }), /*#__PURE__*/_jsx(Grid, {
        className: classNames(s.gridList, _defineProperty({}, s.columnGridList, displayItemsInColumn)),
        spacing: 2,
        container: true,
        direction: displayItemsInColumn ? 'column' : 'row',
        alignItems: displayItemsInColumn ? 'center' : 'flex-start'
      }, void 0, loadedCourses && _.isEmpty(courses) && /*#__PURE__*/_jsx("div", {
        className: s.emptyCourseLabel
      }, void 0, formatMessage(messages.noCoursesHereLabel)), courses.map(function (course) {
        return /*#__PURE__*/_jsx(Grid, {
          xs: 12,
          sm: displayItemsInColumn ? 12 : 6,
          md: displayItemsInColumn ? 12 : 4,
          lg: displayItemsInColumn ? 12 : 3,
          xl: displayItemsInColumn ? 12 : 2,
          className: classNames(s.courseListItem, _defineProperty({}, s.itemsInOneColumn, displayItemsInColumn)),
          item: true
        }, course._id, /*#__PURE__*/_jsx(CourseItem, {
          item: course,
          page: _this2.props.page,
          courses: courses.length,
          afterCourseRemovedFromFavorite: _this2.afterCourseRemovedFromFavorite,
          inOneColumn: displayItemsInColumn,
          searchSessionId: searchSessionId
        }, course._id + displayItemsInColumn));
      }))), this.hasMoreCourses() && loadedCourses && /*#__PURE__*/_jsx("div", {
        className: s.loadMoreButtonWrapper
      }, void 0, /*#__PURE__*/_jsx(Button, {
        variant: "outlined",
        color: "primary",
        disabled: loadingCourses,
        onKeyDown: this.loadMoreCourses,
        onMouseDown: this.loadMoreCourses,
        size: "large",
        id: "load-more-courses"
      }, void 0, loadingCourses ? /*#__PURE__*/React.createElement(FormattedMessage, messages.loadingBtnLabel) : /*#__PURE__*/React.createElement(FormattedMessage, messages.loadMoreBtnLabel), _ExpandMore || (_ExpandMore = /*#__PURE__*/_jsx(ExpandMore, {}))), loadingCourses && /*#__PURE__*/_jsx(CircularProgressSmall, {
        size: 30,
        wrapperClassName: s.buttonProgress
      })), filledSearch && loadedLessons && /*#__PURE__*/_jsx("div", {
        className: classNames(s.listWrapper, filledSearch && loadedLessons && !totalLessons ? s.hidden : undefined),
        id: "lessons-list"
      }, void 0, /*#__PURE__*/_jsx("hr", {
        className: s.searchResultsHr
      }), /*#__PURE__*/_jsx(Typography, {
        className: s.searchResultsTitle,
        component: "h2",
        variant: "h6",
        gutterBottom: true
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.lessons), /*#__PURE__*/_jsx("span", {
        className: s.searchResultsCount
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.searchLessonsResults, {
        values: {
          total: totalLessons > 50 ? "50+" : totalLessons
        }
      })))), loadingLessons && /*#__PURE__*/_jsx(CircularProgressLoader, {
        rootClassName: s.loader
      }), /*#__PURE__*/_jsx(Grid, {
        className: classNames(s.gridList, _defineProperty({}, s.columnGridList, displayItemsInColumn)),
        spacing: 2,
        container: true,
        direction: displayItemsInColumn ? 'column' : 'row',
        alignItems: displayItemsInColumn ? 'center' : 'flex-start'
      }, void 0, loadedLessons && _.isEmpty(lessons) && /*#__PURE__*/_jsx("div", {
        className: s.emptyLessonLabel
      }, void 0, formatMessage(messages.noCoursesHereLabel)), lessons.map(function (lesson) {
        return /*#__PURE__*/_jsx(Grid, {
          xs: 12,
          sm: displayItemsInColumn ? 12 : 6,
          md: displayItemsInColumn ? 12 : 4,
          lg: displayItemsInColumn ? 12 : 3,
          xl: displayItemsInColumn ? 12 : 2,
          className: classNames(s.lessonsListItem, _defineProperty({}, s.itemsInOneColumn, displayItemsInColumn)),
          item: true
        }, lesson._id, /*#__PURE__*/_jsx(LessonItem, {
          item: lesson,
          inOneColumn: displayItemsInColumn,
          searchSessionId: searchSessionId
        }, lesson._id + displayItemsInColumn));
      }))), filledSearch && loadedLessons && loadedCourses && !totalLessons && !totalCourses && /*#__PURE__*/_jsx("div", {
        className: s.listWrapper
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.emptyResultsLabel
      }, void 0, formatMessage(messages.noResultsHere))), filledSearch && loadedLessons && this.hasMoreLessons() && /*#__PURE__*/_jsx("div", {
        className: s.loadMoreButtonWrapper
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "2TCEGjooMqZyopUIIOguH",
        variant: "outlined",
        color: "primary",
        disabled: loadingLessons,
        onClick: this.loadMoreLessons,
        size: "large"
      }, void 0, loadingLessons ? /*#__PURE__*/React.createElement(FormattedMessage, messages.loadingBtnLabel) : /*#__PURE__*/React.createElement(FormattedMessage, messages.loadMoreBtnLabel), _ExpandMore2 || (_ExpandMore2 = /*#__PURE__*/_jsx(ExpandMore, {}))), loadingLessons && /*#__PURE__*/_jsx(CircularProgressSmall, {
        size: 30,
        wrapperClassName: s.buttonProgress
      })), isEditor(auth) && /*#__PURE__*/_jsx("div", {
        className: s.addBtnWrapper
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.addNewCourseTitle),
        enterDelay: 300
      }, void 0, /*#__PURE__*/_jsx(Fab, {
        color: "primary",
        "aria-label": "add",
        component: Link,
        to: "/edit/courses/new",
        className: s.addBtn,
        "data-test": "add-course-btn"
      }, void 0, /*#__PURE__*/_jsx(SkholeIcon17BiggerSize, {
        className: s.addIcon,
        color: "#fff",
        viewBox: " 0 0 28 28"
      }))))), /*#__PURE__*/_jsx(Tour, {
        isOpen: isTourOpen,
        onRequestClose: function onRequestClose() {
          return toggleTour('courses', false);
        },
        update: "".concat(isDashboardExpanded),
        steps: [{
          selector: '#site-search-block, #site-search-categories',
          content: formatMessage(tourMessages.search)
        }, !isTrial(auth) ? {
          selector: '#navigation-menu-btn',
          content: formatMessage(tourMessages.groupMenu)
        } : undefined, {
          selector: '#navigation-help-btn',
          content: formatMessage(tourMessages.help)
        }, {
          selector: '#navigation-notifications-btn',
          content: formatMessage(tourMessages.notifications)
        }, {
          selector: '#navigation-profile-btn',
          content: formatMessage(tourMessages.profile)
        }, {
          selector: isDashboardExpanded ? '#dashboard' : '#toggle-dashboard',
          content: formatMessage(tourMessages.dashboard)
        }, {
          selector: '#courses-list',
          content: formatMessage(tourMessages.coursesList)
        }].filter(function (step) {
          return step !== undefined;
        })
      }));
    }
  }]);
  return Courses;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  page: undefined,
  listMode: false,
  searchSessionId: ''
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
export { Courses as default };